<template>
  <div>
    <HeaderGestion/>
    <SubHeader
    nombre="Datos de catálogo"
    precedente =""/>
    <FormDatCatalogo/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeader from '../components/SubHeader.vue'
import FormDatCatalogo from '../components/FormDatCatalogo.vue'
export default {
  components: { HeaderGestion, SubHeader, FormDatCatalogo },
  name: '',
  mounted () {
    // alertJoa()
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
